import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { NotificationService } from '../../service/notification.service';
import { Observable, Subscription } from 'rxjs';
import { NotificationType } from '../../enum/notification-type.enum';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { animate, state, style, transition, trigger } from '@angular/animations';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { FormControl, NgForm } from '@angular/forms';
import { ProcessService } from '../process.service';
import { ProcessModel } from '../process.model';
import { startWith, debounceTime, distinctUntilChanged, switchMap, map } from 'rxjs/operators';
import { ErrorResponseMessage } from 'src/app/error-handler/error-response-message.model';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { TableColumn } from 'src/app/home/table/TableColumn';

@Component({
  selector: 'app-report-process',
  templateUrl: './report-process.component.html',
  styleUrls: ['./report-process.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ReportProcessComponent implements OnInit, AfterViewInit {
  private subscriptions: Subscription[] = [];
  public refreshing: boolean;
  public ctype: string;
  isChecked: boolean = false;

  excelProcessList: ProcessModel[] = [];

  fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  fileExtension = '.xlsx';
  //fileName: string = 'ReportsData';

  public processModel = new ProcessModel('', 0, 0, '', '', '', null, '', null, '', '', '', '', '', '', '', '');

  public displayedColumns = ['reportName', 'instanceName', 'startTime', 'endTime', 'createdTime', 'status', 'details'];
  public dataSource = new MatTableDataSource<ProcessModel>();

  myDetailsSet = new Set<string>();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;

  columnsExcelData: any;
  dataForExcel = [];
  ordersTableExcelHeaderColumns: TableColumn[];

  supervisorNamesSet = new Set<string>();
  public showLoading: boolean;

  constructor(private router: Router, private processService: ProcessService,
    public ete: ExportExcelService, private httpService: HttpClient, private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.getReports();
    this.initializeExcelHeaders();
  }

  initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.reportProcess;
      }
    );
  }

  exportExcel() {
    for (let js of this.excelProcessList) {
      delete js.id;
      delete js.reportInstanceId;
      delete js.reportDocId;
      delete js.createdBy;
      delete js.updatedDt;
      delete js.updatedBy;
      delete js.reportDesc;
      delete js.distId;
      delete js.distName;
      delete js.distType;
      delete js.distValue;
    }
    this.dataForExcel = [];
    let reportData = null;
    this.excelProcessList.forEach((row: any) => {
      console.log("obj === " + Object.values(row));
      this.dataForExcel.push(Object.values(row));
    })
     reportData = {
      title: 'ReportProcess',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns[0])
    }
    this.ete.exportExcel(reportData);
  }

  public redirectToDetails(url: string, processModel: ProcessModel) {
    this.processModel = processModel;
    this.processService.processModel = this.processModel;
    this.processService.myDetailsSet = this.myDetailsSet;
    this.router.navigate(['/' + url]);
  }

  public getReports(): void {
    this.subscriptions.push(
      this.processService.getReports().subscribe(
        (response: ProcessModel[]) => {
          this.dataSource.data = response;
          this.excelProcessList = JSON.parse(JSON.stringify(response));
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, errorResponse.error.message);
        }
      )
    );
  }


  public redirect(url: string) {
    this.router.navigate(['/' + url]);
  }


  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  public customSort = (event) => {
    console.log(event);
  }

  public doFilter = (value: string) => {
    this.dataSource.filter = value.trim().toLocaleLowerCase();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }


}




